import React, { useState, useEffect } from 'react';
import { MaskMixin } from '../../facades';
import { TextInput } from '../../facades';
import maskObject from './masks';
import styled from 'styled-components';

export interface MaskedInput extends React.InputHTMLAttributes<HTMLInputElement>{
    inputType: 'currency' | 'hours' | 'percent' | 'ssn' | 'ein' | 'phone' | 'zip';
    valueMax?: number;
    onUpdate: any;
    labelText?: string;
    helperText?: string;
    unmask?: boolean;
    containerClass?: string;
    inputClass?: string;
    ref?: React.MutableRefObject<HTMLInputElement | null>;
}
const MaskedStyledInput = MaskMixin(({inputRef, ...props}) => (
    <TextInput      
      helperText=""
      labelText=""
      ref={inputRef}
      id={props.id}
      {...props}
    />
  ));

export const MaskedInput = ({ inputType, valueMax, unmask, onUpdate, labelText, helperText, containerClass, inputClass, ...props }: MaskedInput) => {
    
    const [isInvalid, setInvalid] = useState<boolean>(false);
    const [isComplete, setComplete] = useState<boolean>(false);
    const [isLazy, setLazy] = useState<boolean>(true);
    const [maskedRef, setMaskedRef] = useState<HTMLInputElement>();
    const [inputValue, setValue] = useState('');
    const requiredClass = props.required ? ' required' : '';
    const disabledClass = props.disabled ? ' disabled' : '';
    const invalidClass = isInvalid ? ' invalid' : '';
    const containerClasses = containerClass || '';
    const inputClasses = inputClass || '';

    const onInputUpdate = (value, mask) => {
        setMaskedRef(mask.el.input);
        const submitValue = unmask ? mask.unmaskedValue : mask.value;
        onUpdate(submitValue);
        setValue(submitValue);
    };
    const onBlur = () => {
       setComplete(true);
       setLazy(true);
    };
    const resetValidation = () => {
        if(maskedRef !== undefined) { maskedRef.setCustomValidity('') };
        setInvalid(false);
        setComplete(false);
    };
    const validateField = () => {
      if(maskedRef !== undefined) {
        const regexMasked = new RegExp(maskObject[inputType].pattern, "g");
        const regexUnMasked = new RegExp(maskObject[inputType].um_pattern, "g");
        const regex = unmask ? regexUnMasked : regexMasked;

        if(props.required || inputValue !== '') {
          if(!inputValue.match(regex)) {
              maskedRef.setCustomValidity(`Please match the format ${props.placeholder}`);
              setInvalid(true);
          }
        }
      }
    };

    useEffect(() => { validateField() }, [isComplete]);
    useEffect(() => { resetValidation() }, [inputValue]);

    return (
        <TextInputContainer className={`${containerClasses}${disabledClass}${requiredClass}`}>        
            <MaskedStyledInput 
                blocks={{
                    currency: {
                        mask: Number,
                        signed: true,
                        scale: 2,
                        thousandsSeparator: ',',
                        radix: '.',
                        max: valueMax
                    },
                    decimal: {
                        mask: Number,
                        signed: true,
                        scale: 2,
                        radix: '.',
                        max: valueMax
                    },
                    integer: {
                        mask: Number,
                        signed: true,
                        scale: 0,
                        max: valueMax
                    }
                }}
                mask={maskObject[inputType].mask}
                className={`AD_textInput py-2 px-3${invalidClass} ${inputClasses}${disabledClass}${requiredClass}`}
                data-lpignore="true"
                unmask={unmask}
                lazy={isLazy}
                type={maskObject[inputType].type}
                mode={maskObject[inputType].mode}
                maxLength={255}
                onAccept={(value, mask) => onInputUpdate(value, mask)}
                onBlur={() => onBlur()}
                onInvalidCapture={() => setInvalid(true)}
                onInput={() => {setLazy(false); isInvalid && setInvalid(false)}}
                helperText={helperText}
                labelText={labelText}
                {...props}
            />
        </TextInputContainer>
    );
};

export default MaskedInput;

MaskedInput.default = {
    unmask: true,
    type: 'text',
    lazy: true,
    id: `_ ${Math.random().toString(36).substr(2, 9)}`
}

const TextInputContainer = styled.div``;
